import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	interpolate,
	Interactive,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

const StudioActionsMenuCapture = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 30) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(172 / 30) * fps}
			style={{
				width: 1774,
				height: 1440,
			}}
		>
			<Video
				src="https://remotion.media/studio-close-ups/actions-menu-8f82233a33dd.mp4"
				muted
				durationInFrames={(172 / 30) * fps}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[3, 16, 17, 24, 25, 27, 30, 31, 34, 35, 40, 42, 97],
					[
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 140, 144],
						[3.737112618229373, 3.3634013564064356, 3.737112618229373],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
							21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
							37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
							53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68,
							69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84,
							85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100,
							101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113,
							114, 115, 116, 117, 118, 131, 132, 133, 134, 135, 136, 137,
						],
						[
							'-1099.7621726833127px 2044.4341717101063px',
							'-1173.832912624312px 1539.2378577293878px',
							'-1109.7034761716493px 594.1717101061404px',
							'-944.8763723731031px -51.57507375079834px',
							'-944.8763723731031px -51.57507375079834px',
							'-725.8903318025608px -258.0067516194763px',
							'-487.02168425534506px -370.41209208965665px',
							'-362.12037346796023px -418.6879961071744px',
							'-279.7141206167696px -439.0815364496214px',
							'-265.9481159332137px -440.10340318116846px',
							'-240.54742860618595px -439.2421155074359px',
							'-108.62443356345611px -420.32298287764974px',
							'138.94467929807487px -372.4266293604209px',
							'625.0758796873574px -277.2324442687266px',
							'834.9235120586358px -243.36486116602293px',
							'1078.142392263009px -219.73054347495514px',
							'1088.5508348286246px -216.51896231866428px',
							'1089.1493567713878px -216.09561752988049px',
							'1088.0982938475108px -216.09561752988049px',
							'1085.2954593838388px -214.6796022018795px',
							'1076.9891426659774px -204.50472917490345px',
							'1052.9460782822907px -181.39594294577415px',
							'957.897874152246px -48.93281834494085px',
							'912.4831969830602px 38.0134424135519px',
							'897.6661293756273px 71.384690246647px',
							'884.411058057845px 107.3252030047748px',
							'875.7835832243545px 129.36832821386213px',
							'872.3968249140842px 139.0760621635595px',
							'862.1927556947782px 172.31592713116999px',
							'851.1857911863995px 209.17611994769015px',
							'843.1568382956723px 237.45263221921476px',
							'837.0986283872146px 265.18901493263587px',
							'833.2155348073356px 291.1298318177671px',
							'827.6828563608163px 325.4791520939144px',
							'824.9676104741341px 346.41282199446493px',
							'823.1428484535143px 353.5512910191296px',
							'821.1575073750798px 365.14217937410666px',
							'818.9677929503362px 378.45564307654877px',
							'815.3328670052614px 396.9076366290563px',
							'813.6102916577963px 406.03144673215536px',
							'810.3841124053405px 425.9870441896536px',
							'809.3476475776284px 439.1107326419513px',
							'808.7053313463703px 451.15416197804205px',
							'808.1652017882668px 461.13925975487365px',
							'807.1287369605548px 472.2922052249019px',
							'805.1725920744503px 484.86116602293123px',
							'804.4134910738725px 496.87539916669203px',
							'802.9536814573767px 508.7290532526383px',
							'802.457346187768px 527.9109516133938px',
							'802.7785043033972px 533.9545634256866px',
							'806.661597883276px 552.3043703050395px',
							'814.2380097928896px 575.4277546303337px',
							'820.8363492594508px 599.8357714181443px',
							'824.5588637815152px 618.7403059517654px',
							'824.5588637815152px 618.7403059517654px',
							'825.2887685897631px 649.2503269365287px',
							'824.8362276086494px 658.6077065782671px',
							'824.8362276086494px 671.9357683768742px',
							'824.6026580700101px 677.5414373042183px',
							'823.5078008576382px 690.285575256227px',
							'822.9092789148749px 701.9348559958639px',
							'821.7414312216782px 716.5621483531523px',
							'821.7414312216782px 716.5621483531523px',
							'819.712295854749px 742.0358261610049px',
							'818.4860557768925px 755.0573279401478px',
							'817.4641890453454px 767.3781211033728px',
							'815.3620631975914px 781.363097229403px',
							'813.6394878501262px 796.7202943949394px',
							'810.938840059609px 810.938840059609px',
							'808.807518019525px 823.201240838174px',
							'808.807518019525px 823.201240838174px',
							'805.3331711322649px 848.8500958000061px',
							'804.6324625163469px 858.1198868647548px',
							'804.0485386697485px 870.35309145099px',
							'802.5157385724278px 882.323530306256px',
							'800.9099479942824px 897.6807274717922px',
							'798.3844773577447px 913.5780541954321px',
							'795.6692314710624px 929.3877923420821px',
							'795.6692314710624px 929.3877923420821px',
							'788.8665186581917px 976.1162981661142px',
							'787.9906328882942px 983.1525805176242px',
							'785.0710136553025px 996.94778139351px',
							'781.9470210760014px 1009.3707612298897px',
							'779.6843161704328px 1022.6404306438369px',
							'778.5164684772361px 1029.4723396490374px',
							'778.5164684772361px 1029.4723396490374px',
							'769.9327879322406px 1063.5588941942156px',
							'767.1737477570634px 1072.7848909704694px',
							'765.4803686019283px 1082.3466439585172px',
							'764.2979228125665px 1092.7112922356378px',
							'763.4220370426691px 1100.740245126365px',
							'762.3709741187921px 1111.5866305769289px',
							'760.3418387518628px 1121.9512788540494px',
							'758.0499376539643px 1132.1407499771906px',
							'757.2178461725617px 1137.8194093853594px',
							'754.2544326510751px 1156.884522976795px',
							'752.0939144186613px 1168.7381770627414px',
							'750.4005352635261px 1182.635564611782px',
							'748.677959916061px 1193.2921748122017px',
							'746.546637875977px 1205.2772117636325px',
							'744.5175025090479px 1219.919102217086px',
							'743.2036738542016px 1237.1886499802317px',
							'741.8314528146955px 1249.9035917399106px',
							'739.3935707551474px 1263.6258021349715px',
							'737.6563973115174px 1279.9902679358902px',
							'735.8316352908976px 1289.9607676165567px',
							'734.6199933092059px 1297.4203947568506px',
							'733.233174173535px 1299.33274535446px',
							'725.6567622639215px 1303.0844560688545px',
							'693.2635868738786px 1314.0622243849032px',
							'627.4699674584107px 1339.8862565007148px',
							'511.18153340835136px 1419.5918615613882px',
							'333.8000669079408px 1567.4997719047476px',
							'333.8000669079408px 1567.4997719047476px',
							'-138.78410024026033px 1983.0637754326208px',
							'-414.2209786806971px 2234.1948237584015px',
							'-414.2209786806971px 2234.1948237584015px',
							'-1054.989811745385px 2216.516529302637px',
							'-1070.5367841610657px 2193.3201544965177px',
							'-1093.3828046592257px 2164.737082205529px',
							'-1107.9079103433594px 2145.2194276329797px',
							'-1113.309205924394px 2136.8547185304583px',
							'-1113.4697849822087px 2136.4605699340045px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

const StudioActionsMenuContent = () => {
	const {width, height} = useVideoConfig();

	return (
		<AbsoluteFill showInTimeline={false} style={{backgroundColor: '#1f2327'}}>
			<AbsoluteFill
				name="Actions menu - tilted close-up"
				style={{
					width: 1774,
					height: 1440,
					left: '50%',
					top: '50%',
					translate: '-900px -740px',
					transformOrigin: '900px 740px',
					rotate: '-3deg',
					scale: 1.65 * Math.min(width / 2560, height / 1600),
				}}
			>
				<StudioActionsMenuCapture />
			</AbsoluteFill>
		</AbsoluteFill>
	);
};

export const StudioActionsMenuComposition = Interactive.create({
	Component: StudioActionsMenuContent,
	layout: 'absolute-fill',
	schema: Interactive.backgroundSchema,
});
